import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import { moneyFormat } from "../../services/currencyService";
import Button from "../atoms/Button";
import { getRedirectUrl } from "../../services/paymentService";
import Paragraph from "../atoms/Paragraph";
import SelectItem from "../atoms/SelectItem";
import ArrowRight from "../atoms/icons/ArrowRight";
import ErrorNotice from "../atoms/ErrorNotice";
import { useTranslation } from "react-i18next";

const StyledErrorNotice = styled(ErrorNotice)`
  margin-bottom: 20px;
`;

const ButtonWrapper = styled.div`
  text-align: right;
  margin-top: 30px;
`;

const StyledSelectItem = styled(SelectItem)`
  margin-top: 10px;
`;

const StyledArrowRight = styled(ArrowRight)`
  width: 15px;
  height: 11px;
  fill: white;
`;

const StyledParagraph = styled(Paragraph)`
  margin-top: 30px;
`;

const PayScheduledPaymentModal = ({ period }) => {
  const { t } = useTranslation(["common", "dossier"]);
  const data = useSelector(state => state.data);
  const schedules = data.paymentPlan.schedule;
  const dispatch = useDispatch();
  const [payment, setPayment] = useState({ loading: false });
  const [error, setError] = useState("");

  const currentSchedule = schedules.find(schedule => schedule.date === period);

  if (!currentSchedule) {
    return <p>{t("dossier:arrangement.not_found")}</p>;
  }

  const submit = () => {
    setPayment({ ...payment, loading: true });

    dispatch(
      getRedirectUrl({
        period: currentSchedule.date,
        type: "period",
      })
    )
      .then(response => (window.location.href = response.redirect_uri))
      .catch(err => {
        setPayment({ ...payment, loading: false });
        setError(err.message);
      });
  };

  return (
    <>
      {error && <StyledErrorNotice>{error}</StyledErrorNotice>}
      <Paragraph>
        {t("dossier:arrangement.term_amount", {
          amount: moneyFormat(currentSchedule.amount),
        })}
      </Paragraph>
      <ButtonWrapper>
        <Button
          onClick={submit}
          secondary
          reversed
          icon={<StyledArrowRight />}
          loading={payment.loading ? 1 : 0}
        >
          {t("dossier:payment.with_ideal")}
        </Button>
      </ButtonWrapper>
    </>
  );
};

export default PayScheduledPaymentModal;
